/* eslint-disable no-undef */
import React from "react"
// import PropTypes from "prop-types"
import {  useSearchBox } from 'react-instantsearch';
function CustomSearchBox( props ) {
  const { query, refine } = useSearchBox();
 /* var propTypes = {
		currentRefinement: PropTypes.string,
		refine: PropTypes.func.isRequired,
		placeholder: PropTypes.string,
		onKeyUp: PropTypes.func,
		onReset: PropTypes.func,
		resetComponent: PropTypes.element,
	};

	var defaultProps = {
		currentRefinement: "",
		placeholder: "",
		onKeyUp: null,
		onReset: null,
		resetComponent: null,
	};
	 */

	const onSubmit = (e) => {
		e.preventDefault()
		return false
	};

	const onChange = (e) => {
		const query = e.target.value

		if (query.match(/^[m|M][a-zA-Z]{1}[0-9]{2}/)) {
			setModelCode(query)
		} else {
			 setQuery(query)
		}
	};

	const onReset = () => {
		setQuery("")
	};

	const setQuery = (val) => {
		refine(val, null)
	};

	const setModelCode = (val) => {
		const { query, refine } = useSearchBox();
		refine(val, val.substr(0, 4))
	}

	// const getQuery = () => this.props.currentRefinement;

  return (
   <form
                noValidate
                onSubmit={onSubmit}
                onReset={onReset}
                action=""
                role="search"
            >
                <div role="search" className="ais-SearchBox__wrapper">
                    <input
                        type="search"
                        placeholder={props.placeholder}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        required
                        maxLength="512"
                        onChange={onChange}
                        className="ais-SearchBox__input"
                        onKeyUp={props.onKeyUp}
						id={'SearchBox'}
                    />
                    <button type="submit" className="ais-SearchBox__submit">
                        <svg width="1em" height="1em" stroke="#000"><use xlinkHref="#search-icon" /></svg>
                    </button>
                    {props.onReset &&
                        <button className="ais-SearchBox__reset" type="reset" onClick={props.onReset}>
                            {props.resetComponent}
                        </button>}
                </div>
            </form>
  );
};
export default CustomSearchBox